import { render, staticRenderFns } from "./DeviceIncomePayments.vue?vue&type=template&id=f28d1ddc&scoped=true&"
import script from "./DeviceIncomePayments.vue?vue&type=script&lang=js&"
export * from "./DeviceIncomePayments.vue?vue&type=script&lang=js&"
import style0 from "./DeviceIncomePayments.vue?vue&type=style&index=0&id=f28d1ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d1ddc",
  null
  
)

export default component.exports